import { useRouter } from 'next/router';

export const useOrderIdFromQuery = () => {
  const {
    query: { orderId },
  } = useRouter();

  return (orderId as string) || '';
};
